import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'

const STATE_COLORS: Record<string, string> = {
  PAID: '#2e7d32',
  APPROVED: '#0288d1',
  IN_PROGRESS: '#ed6c02',
  SUBMITTED: '#757575',
  REJECTED: '#d32f2f',
  DRAFT: '#9e9e9e',
}

const STATE_LABELS: Record<string, string> = {
  PAID: 'Paid',
  APPROVED: 'Approved',
  IN_PROGRESS: 'In progress',
  SUBMITTED: 'Submitted',
  REJECTED: 'Rejected',
  DRAFT: 'Draft',
}

type StateMixBarProps = {
  data: { state: string; count: number }[]
}

const StateMixBar: React.FC<StateMixBarProps> = ({ data }) => {
  const total = data.reduce((sum, s) => sum + s.count, 0)
  if (total === 0) return null

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          height: 22,
          borderRadius: 1,
          overflow: 'hidden',
          border: 1,
          borderColor: 'divider',
        }}
      >
        {data.map((entry) => (
          <Tooltip
            key={entry.state}
            title={`${STATE_LABELS[entry.state] || entry.state}: ${entry.count}`}
          >
            <Box
              sx={{
                width: `${(entry.count / total) * 100}%`,
                bgcolor: STATE_COLORS[entry.state] || '#9e9e9e',
                height: '100%',
              }}
            />
          </Tooltip>
        ))}
      </Box>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, mt: 1.5 }}>
        {data.map((entry) => (
          <Box key={entry.state} sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
            <Box
              sx={{
                width: 9,
                height: 9,
                borderRadius: 0.5,
                bgcolor: STATE_COLORS[entry.state] || '#9e9e9e',
                flex: 'none',
              }}
            />
            <Typography variant="caption" color="text.secondary">
              {STATE_LABELS[entry.state] || entry.state}{' '}
              <Typography component="span" variant="caption" sx={{ fontWeight: 700, color: 'text.primary' }}>
                {entry.count}
              </Typography>
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default StateMixBar
